import { useSelector } from 'react-redux';
import { AirdropNotifState, State } from '../types';

export const useAirdropNotifState = (): AirdropNotifState => {
  return useSelector((state: State) => state.airdropNotif)
}
